import React from 'react';
import styled from 'styled-components';
import { Title, Icon } from 'components';
import TourAutoSaveIndicator from '../TourHeaderMenu/TourAutoSaveIndicator';

interface ModalMobileHeaderProps {
  title: string;
  handleBackIconClick: () => void;
}

const ModalMobileHeader = ({
  title,
  handleBackIconClick,
}: ModalMobileHeaderProps) => (
    <StyledContainer>
      <StyledIconContainer onClick={handleBackIconClick}>
        <Icon type="antdArrowLeftOutlined" />
      </StyledIconContainer>
      <StyledTitle level={3} textAlign="center">
        {title}
      </StyledTitle>
      <TourAutoSaveIndicator />
    </StyledContainer>
  );

export default ModalMobileHeader;

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.2rem 0rem 1.2rem 1.2rem;
`;

const StyledTitle = styled(Title)`
  margin: 0 !important;
  flex-grow: 1;
`;

const StyledIconContainer = styled.div`
  cursor: pointer;
`;
